import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Users, Zap } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-cyber-dark relative overflow-hidden" data-id="element-1">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cyber-purple/5 skew-x-12 transform origin-top-right" data-id="element-2" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-5">
            <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-white mb-6" data-id="element-6">
              FORGED IN <span className="text-cyber-green" data-id="element-7">SILICON</span>
            </h2>
            <p className="text-xl text-gray-300 font-rajdhani mb-6 leading-relaxed" data-id="element-8">
              Alphagamer isn't just a computer club; it's a nexus for the
              digital vanguard. Established in 2026, we built a sanctuary where
              hardware meets soul.
            </p>
            <p className="text-lg text-gray-400 font-rajdhani mb-8 leading-relaxed" data-id="element-9">
              Located in the heart of London, our facility is designed for one
              purpose: absolute immersion. Whether you're a competitive esports
              athlete, a casual explorer of virtual worlds, or a developer
              building the next metaverse, our grid is your home.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-10">
              <div className="p-4 border border-cyber-green/20 bg-cyber-black/50" data-id="element-11">
                <Cpu className="w-8 h-8 text-cyber-green mb-2" data-id="element-12" />
                <h4 className="font-orbitron text-white" data-id="element-13">Top Tier Tech</h4>
              </div>
              <div className="p-4 border border-cyber-cyan/20 bg-cyber-black/50" data-id="element-14">
                <Users className="w-8 h-8 text-cyber-cyan mb-2" data-id="element-15" />
                <h4 className="font-orbitron text-white" data-id="element-16">Community</h4>
              </div>
              <div className="p-4 border border-cyber-purple/20 bg-cyber-black/50" data-id="element-17">
                <Zap className="w-8 h-8 text-cyber-purple mb-2" data-id="element-18" />
                <h4 className="font-orbitron text-white" data-id="element-19">Gigabit Speed</h4>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-20">
            <div className="relative aspect-square max-w-md mx-auto" data-id="element-21">
              <div className="absolute inset-0 border-2 border-cyber-purple/50 rounded-lg transform rotate-3" data-id="element-22" />
              <div className="absolute inset-0 border-2 border-cyber-cyan/50 rounded-lg transform -rotate-3" data-id="element-23" />
              <div className="absolute inset-0 bg-cyber-black flex items-center justify-center overflow-hidden rounded-lg border border-gray-800" data-id="element-24">
                <div className="text-center p-8" data-id="element-25">
                  <div className="text-6xl font-orbitron font-black text-white/10 mb-4" data-id="element-26">
                    2026
                  </div>
                  <h3 className="text-3xl font-orbitron text-white mb-2" data-id="element-27">
                    ESTABLISHED
                  </h3>
                  <div className="w-16 h-1 bg-cyber-pink mx-auto mb-4" data-id="element-28" />
                  <p className="font-rajdhani text-gray-400" data-id="element-29">
                    The year everything changed.
                  </p>
                </div>

                {/* Animated scan line inside the box */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyber-green/10 to-transparent h-full w-full animate-[pulse_3s_ease-in-out_infinite]" data-id="element-30" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}